export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  traceId?: string;
  errors?: Record<string, string[]>;
  [key: string]: unknown;
}

export class ApiError extends Error {
  readonly status: number;
  readonly problem?: ProblemDetails;
  readonly correlationId?: string;

  constructor(
    message: string,
    status: number,
    problem?: ProblemDetails,
    correlationId?: string,
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.problem = problem;
    this.correlationId = correlationId;
  }
}

const translateKnownApiMessage = (message: string): string => {
  const knownMessages: Record<string, string> = {
    "Tenant code already exists.": "این کد سازمانی قبلاً ثبت شده است. لطفاً کد دیگری وارد کنید.",
    "This email already has an account. Use a different email so the initial password is unambiguous.":
      "این ایمیل قبلاً دارای حساب کاربری است. برای مدیر اولیه شرکت از ایمیل دیگری استفاده کنید.",
    "This email already belongs to another account.":
      "این ایمیل قبلاً به حساب کاربری دیگری اختصاص یافته است.",
    "The If-Match header is required.":
      "نسخه سرنخ دریافت نشد؛ صفحه را تازه‌سازی و دوباره ویرایش کنید.",
    "The If-Match header is invalid.":
      "نسخه سرنخ معتبر نیست؛ صفحه را تازه‌سازی و دوباره تلاش کنید.",
    "The lead has changed since it was loaded.":
      "این سرنخ پس از باز شدن فرم تغییر کرده است. صفحه را تازه‌سازی کنید تا آخرین نسخه را ببینید.",
  };
  return knownMessages[message] ?? message;
};

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof ApiError) {
    const validation = error.problem?.errors;
    if (validation) {
      const first = Object.values(validation).flat()[0];
      if (first) return translateKnownApiMessage(first);
    }
    return translateKnownApiMessage(error.problem?.detail || error.problem?.title || error.message);
  }

  if (error instanceof Error) return translateKnownApiMessage(error.message);
  return 'خطای پیش‌بینی‌نشده‌ای رخ داد.';
};
